//import React from 'react';

import React, {useState, useEffect} from 'react';  
//import { Col } from 'react-bootstrap';
//import { Link } from 'react-router-dom';
import { removeFromCart, updateItems,updateSubTotal } from '../redux/slices/CartSlice';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { Link } from 'react-router-dom';
import  paths  from '../routes/paths';
import { toast } from 'react-toastify';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faPlus,faMinus } from '@fortawesome/free-solid-svg-icons';

const  SideBarCart = ({showCart, onClose}) => {
   const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    //const [tabPane, SetTabPane] = useState('cart');
    //const { wl_products,loggedInUser} = useSelector((state:any) => state.auth)
    const {cart} = useSelector((state:any) => state.cart)
    const [subTotal, setSubTotal] = useState(0);
    const [cartItems, setCartItems] = useState([] as any);
    const [shippingCharges, setShippingCharges] = useState(80);

      
      useEffect(() =>{
        const calShippingCharges = () => {
            const k = cart['line_items'].length;
            const shippingCharge = 5 *( k * k) + (25 * k) + 50;
            setShippingCharges(shippingCharge);
        }
       if (cart && cart['line_items'] && cart['line_items'].length > 0){calShippingCharges()};
     },[cart]);

    // const increaseQty = (id) => {
    //     if (quantity < 5){
    //       const qty = quantity + 1
    //       setQuantity(qty)
    //       getPrice(selectedGender,selectedCategory,selectedSize,qty);
    //     }
    // }
    // const decreaseQty = (id) => {
    //   if (quantity > 0){
    //     const qty = quantity - 1
    //     setQuantity(qty)
    //     getPrice(selectedGender,selectedCategory,selectedSize,qty);
    //   }
    // }
    // const finalPrice = parseInt(price) * qty;
    // const finalStrikePrice = parseInt(strikePrice) * qty;

//     const increaseQty = (id) => { 
//          const cItems = cartItems.map(item => 
//           item.id === id ? {
//              ...item, 
//                  quantity: item.quantity < 5 ? (item.quantity + 1) : item.quantity
//             } : item
//         ); 
        
//     setCartItems(cItems);
//     dispatch(updateItems(cItems));
//     calSubTotal(cItems); 
//    }
   
//    const decreaseQty = (id) => {
//     const cItems = cartItems.map(item => 
//         item.id === id ? { 
//             ...item, 
//             quantity: item.quantity > 1 ?  (item.quantity - 1) : item.quantity
//         } : item)
//     setCartItems(cItems);
//     dispatch(updateItems(cItems));
//     calSubTotal(cItems); 
//    }
   const manageItemRemove = (item_id) => {
    dispatch(removeFromCart(item_id))
   }


    
   
    const updateCart = () => {
        const arr = cartItems.map(item => ({ id: item.id, quantity: item.quantity }));
        dispatch(updateItems(arr));
        toast.success("Cart items updated successfully.");
    }
 
    const handleCheckoutBtn = () => {
        onClose(false);
        updateCart();
    }
    const  roundOff = (value) => {
        return Math.round(value)
      }

  useEffect(() =>{
    const calSubTotal = (line_items) => {
        if(line_items ){
            let total = 0;
            line_items.map((item) => 
                    total = total + (item.price * item.quantity) 
                )
                setSubTotal(total)
                dispatch(updateSubTotal(total))
            }
        }

        
     setCartItems(cart.line_items)
     calSubTotal(cart.line_items)

  },[cart,dispatch]) 
  //console.log("cart Itesm",cartItems,cartItems && cartItems.length)
  return (
    <div className={"cart-sidebar offcanvas dz-offcanvas offcanvas offcanvas-end " + (showCart === true ? 'show' : '') }  id="offcanvasRight">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => onClose(false)}>
            &times;
        </button>
        <div className="offcanvas-body">
            <div className="product-description">
                <div className="dz-tabs">
                    <ul className="nav nav-tabs center" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link  active"  id="shopping-cart"  type="button">Shopping Cart
                              <span className="badge badge-light">{cart && cart.line_items && cart.line_items.length }</span>
                            </button>
                        </li>
                        {/* <li className="nav-item" role="presentation">
                            <button className={"nav-link " +   (tabPane === 'wishlist' ? 'active' : '')} id="wishlist"  onClick={() => SetTabPane('wishlist')}  type="button">Wishlist
                              <span className="badge badge-light">2</span>
                            </button>
                        </li> */}
                    </ul>
                    <div className="tab-content pt-4" id="dz-shopcart-sidebar">
                        <div className="tab-pane fade show active"  id="shopping-cart-pane"   aria-labelledby="shopping-cart" >
                            <div className="shop-sidebar-cart">
                            { cart && cart.line_items && cart.line_items.length === 0 && "Your cart is empty. Please add one!"} 
                                <ul className="sidebar-cart-list ">
                                  {cartItems && cartItems.map((item) =>
                                    <li key={item.id}>
                                      <div className="cart-widget">
                                          <div className={"dz-media me-3 tshirtImage " } >
                                            <img src={process.env.REACT_APP_SERVER_URL + (item.variant.variant_images[0] ? item.variant.variant_images[0].variant_image.webp.url : '')} alt="product" className='product Image'/>
                                          </div>
                                          <div className="cart-content">
                                                <h6 className="title">{item.variant.product.name}</h6>
                                                <div className="d-flex align-items-center">
                                                    {/* <div className="btn-quantity light quantity-sm me-3">
                                                        <button className="btn btn-default bootstrap-touchspin-down m-r10" type="button" onClick={() => decreaseQty(item.id)}><FontAwesomeIcon icon={faMinus}  /></button>
                                                            <div className="sidebar-qty">{item.quantity} </div> 

                                                        <button className="btn btn-default bootstrap-touchspin-up m-l10" type="button" onClick={() => increaseQty(item.id)} ><FontAwesomeIcon icon={faPlus} /></button>
                                                        
                                                    </div> */}
                                                    <h6 className="dz-price mb-0">₹{roundOff(item.price)} <del className='m-r10'>₹{roundOff(item.actual_price)}</del> </h6>
                                                </div>
                                                {item.size  && (
                                                     <div className="d-flex align-items-center"> 
                                                        <h6 className="dz-price mb-0">Size: {item.size}  </h6>
                                                    </div>
                                                )}
                                                
                                          </div>
                                          <button onClick={() => manageItemRemove(item.id)} className="dz-close removeBtnBG">
                                            <i className="ti-close"></i>
                                          </button>
                                      </div>
                                    </li>
                                  )} 
                                </ul>
                            {cartItems && cartItems.length > 0 && (
                                <>
                                    <div className="cart-total pb-0">
                                        <h5 className="mb-0">Subtotal:</h5>
                                        <h5 className="mb-0">₹{subTotal}</h5>
                                    </div> 
                                    <div className=" p-0 cart-total">
                                        <h5 className="mb-0">Shipping:</h5>
                                        <h5 className="mb-0">₹{shippingCharges}</h5>
                                    </div> 
                                    <hr/>
                                    <div className=" p-0 cart-total">
                                        <h5 className="mb-0">Total:</h5>
                                        <h5 className="mb-0">₹{subTotal + shippingCharges}</h5>
                                    </div>
                                </> 
                            )}
                            
                            <div className="mt-auto">
                                {/* <div className="shipping-time">													
                                    <div className="dz-icon">
                                        <i className="flaticon flaticon-ship"></i>
                                    </div>
                                    <div className="shipping-content">
                                        <h6 className="title pe-4">Congratulations , you've got free shipping!</h6>
                                        <div className="progress">
                                            <div className="progress-bar progress-animated border-0"  role="progressbar">
                                                <span className="sr-only">75% Complete</span>
                                            </div>
                                        </div> 
                                    </div>
                                </div> */}
                                {cartItems &&  cartItems.length > 0 && (
                                    <>
                                        {/* <button onClick={() => updateCart()} className="btn btn-outline-secondary btn-block m-b20">Update Cart</button>	 */}
                                        <Link to={paths.checkout} onClick={() => handleCheckoutBtn()} className="btn btn-secondary btn-block">Checkout</Link> 
                                    </>
                                )}
                            </div>	
                            </div>	
                        </div>
                        {/* <div className={"tab-pane fade " + (tabPane === 'wishlist' ? 'show active' : '')} id="wishlist-pane" aria-labelledby="wishlist" >
                            <div className="shop-sidebar-cart">
                                <ul className="sidebar-cart-list">
                                {wl_products && wl_products.map((product) =>
                                    <li>
                                        <div className="cart-widget">
                                            <div className="dz-media me-3">
                                                <img src="images/shop/shop-cart/pic1.jpg" alt=""/>
                                            </div>
                                            <div className="cart-content">
                                                <h6 className="title"><a href="product-thumbnail.html">Sophisticated Swagger Suit</a></h6>
                                                <div className="d-flex align-items-center">
                                                    <h6 className="dz-price  mb-0">$50.00</h6>
                                                </div>
                                            </div>
                                            <a href="#!;" className="dz-close">
                                                <i className="ti-close"></i>
                                            </a>
                                        </div>
                                    </li>
                                  )}
                                </ul>
                                <div className="mt-auto">
                                    <a href="shop-wishlist.html" className="btn btn-secondary btn-block">Check Your Favourite</a>
                                </div>	
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default SideBarCart;

 
